<template>
    <el-form ref="form" class="x-form" @submit.prevent :label-width="getLabelWidth(config.labelWidth)" :inline="true"
        :validate-on-rule-change="false" :model="data" :rules="getRules(config.rules)">
        <el-row :span="24">
            <template v-for="(fieldConfig, index) in getFields(config.fields)" :key="index">
                <el-col class="col" v-if="getVisible(fieldConfig.visible, data)"
                    :span="getSpan(fieldConfig, config.itemWidth)"
                >
                    <slot name="field" :config="fieldConfig" :readonly="readonly || fieldConfig.readonly" :query-params="queryParams" v-if="fieldConfig.isBusinessField"></slot>
                    <el-form-item v-else
                        :label="fieldConfig.name ? fieldConfig.name + '：' : ''"
                        :prop="fieldConfig.field"
                            class="xm-col-item"
                    >
                        <x-item 
                            :config="fieldConfig"
                            :data="data"
                            :field="fieldConfig.field"
                            :readonly="readonly"
                            @button-click="(button, config)=> $emit('buttonClick', button, data, config)"
                            @link-click="(value, config)=> $emit('linkClick', value, data, config)"
                            @value-changed="valueChangedHandler"
                        ></x-item>
                    </el-form-item>
                </el-col>
            </template>
        </el-row>
    </el-form>
</template>
<script setup>
import { defineProps, watch, ref, getCurrentInstance } from 'vue';
import { getBoolean } from '../../business/Computer';
import XItem from './XItem.vue';
import XTable from './XTable.vue';
import FieldType from '../../datamodule/FieldType';

const inst = getCurrentInstance();

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    data: { default: null },

    queryParams: { default: null },
})

defineEmits({
    'valueChanged': null,
    'buttonClick': null,
    'linkClick': null,
})

const getLabelWidth = (width) => {
    if (width === 0) return null;
    return width || 180;
}
const getFields = (fields) => {
    return fields || [];
}
const getRules = (rules) => {
    return rules;
}
const getVisible = (visible, data) => {
    // console.log('sssssssssssss', visible, data)
    return getBoolean(visible, data, true);
}
const getSpan = (fieldConfig, defaultWidth) => {
    if (fieldConfig.isBusinessField) return 24;
    return fieldConfig.width || defaultWidth || 8;
}
const resetForm = ()=> {
    inst.refs.form['resetFields']();
}
const validateForm = async ()=> {
    return inst.refs.form['validate']((valid)=> {
        if (valid) return true;
        else return false;
    });
}
const valueChangedHandler = (value, config)=> {
    inst.emit('valueChanged', value, config)
}

defineExpose({
    resetForm,
    validateForm,
})
</script>
<style scoped>
.x-form {
    width: 100%;
}
.col {
    text-align: left;
    
    /* background:#fff; */
}
.xm-col-item{
    padding: 10px;
}
.x-form>>>.mx-1 {
    margin: 0 4px;
    font-size: 14px;
}
.el-form--inline >>>.el-form-item{
    display: flex;
}
</style>